export enum AssessmentSectionStatus {
    Loading = 'loading',
    Empty = 'empty',
    ServingBaselineAssessment = 'showingBaselineAssessment',
    ServingProgressAssessment = 'servingProgressAssessment',
    ServingDCI = 'servingDCI',
    ServingSuperlative = 'servingSuperlative'
}
